<ng-container *ngIf="zone">
    <div (click)="openGenerateCode(this.lightZone)">
        <mx-image-carousel [images]="images"></mx-image-carousel>
        <label>{{zone.description}}</label>
    </div>
</ng-container>
